var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBcio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3F43AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.94 7.436a.877.877 0 000 1.751.877.877 0 000-1.751m4.05-2.43a.877.877 0 000 1.752.877.877 0 000-1.752m0 9.719a.877.877 0 000 1.751.877.877 0 000-1.751m4.049-2.43a.876.876 0 10.002 1.753.876.876 0 00-.002-1.753m4.049-2.429a.877.877 0 10.002 1.753.877.877 0 00-.002-1.753M11.94 17.155a.877.877 0 000 1.751.877.877 0 000-1.751M7.89 9.866a.876.876 0 10.002 1.752.876.876 0 00-.002-1.752m0 9.718a.876.876 0 10.002 1.753.876.876 0 00-.002-1.753m0-4.859a.877.877 0 000 1.751.877.877 0 000-1.751m8.1-4.859a.877.877 0 100 1.753.877.877 0 000-1.753m4.049-2.43a.877.877 0 10.002 1.753.877.877 0 00-.002-1.753m0 9.719a.876.876 0 10.001 1.752.876.876 0 00-.001-1.752m4.049-2.43a.877.877 0 000 1.751.877.877 0 000-1.751m-4.049 7.289a.876.876 0 10.001 1.753.876.876 0 00-.001-1.753m4.049-2.43a.877.877 0 000 1.752.877.877 0 000-1.752m-8.098 4.86a.877.877 0 000 1.751.877.877 0 00.876-.875.877.877 0 00-.876-.876m0-4.86a.877.877 0 10.001 1.754.877.877 0 00-.001-1.754m-4.05-7.289a.877.877 0 000 1.751.877.877 0 000-1.75m0 9.718a.877.877 0 000 1.751.877.877 0 000-1.751",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcio);
export default __webpack_public_path__ + "static/media/bcio.7370f484d560aaa3be5d9db23fb13ad2.svg";
export { ForwardRef as ReactComponent };